import React from "react";
import Button from "@material-ui/core/Button";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import DialogActions from "@material-ui/core/DialogActions";
import Dialog from "@material-ui/core/Dialog";

const ConfirmationDialog = ({
  open,
  title,
  children,
  okDisabled = false,
  cancelDisabled = false,
  hideCancel = false,
  onOk,
  onCancel,
  ...other
}) => {
  return (
    <Dialog
      disableBackdropClick
      disableEscapeKeyDown
      maxWidth="xs"
      aria-labelledby="confirmation-dialog-title"
      open={open}
      {...other}
    >
      <DialogTitle id="confirmation-dialog-title">{title}</DialogTitle>
      <DialogContent dividers>{children}</DialogContent>
      <DialogActions>
        {!hideCancel && (
          <Button autoFocus disabled={cancelDisabled} onClick={onCancel} color="primary">
            Cancelar
          </Button>
        )}
        <Button disabled={okDisabled} onClick={onOk} color="primary">
          Aceptar
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ConfirmationDialog;
